import {EventEmitter, Injectable, Output} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ApplicationEventsService {
    constructor() {
    }

    @Output() pageReload: EventEmitter<null> = new EventEmitter();

    triggerPageReload() {
        this.pageReload.emit();
    }

}
